var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#4776E6",
    fillOpacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77778 15.2V18.4C9.77778 21.04 9.77778 22.36 10.575 23.18C11.3722 24 12.6556 24 15.2222 24H16.7778C19.3444 24 20.6278 24 21.425 23.18C22.2222 22.36 22.2222 21.04 22.2222 18.4V15.2M16 11.0856C16 10.2672 15.6839 9.48241 15.1214 8.90375C14.5588 8.32509 13.7957 8 13.0001 8H12.7224C11.9556 8 11.3333 8.6392 11.3333 9.4288C11.3333 10.1107 11.5967 10.7647 12.0655 11.2469C12.5343 11.7291 13.1701 12 13.8331 12H16M16 11.0856V12M16 11.0856C16 10.2672 16.3161 9.48241 16.8786 8.90375C17.4412 8.32509 18.2043 8 18.9999 8H19.2776C20.0444 8 20.6667 8.6392 20.6667 9.4288C20.6667 9.76645 20.602 10.1008 20.4764 10.4128C20.3508 10.7247 20.1666 11.0082 19.9345 11.2469C19.7024 11.4857 19.4268 11.6751 19.1235 11.8043C18.8202 11.9335 18.4952 12 18.1669 12H16M16 15.2V24M9 13.6C9 13.0016 9 12.7024 9.15633 12.48C9.26722 12.3272 9.41419 12.206 9.58333 12.128C9.854 12 10.2172 12 10.9444 12H21.0556C21.7828 12 22.146 12 22.4167 12.128C22.594 12.2128 22.741 12.3344 22.8437 12.48C23 12.7024 23 13.0016 23 13.6C23 14.1984 23 14.4968 22.8437 14.72C22.7328 14.8728 22.5858 14.994 22.4167 15.072C22.146 15.2 21.7828 15.2 21.0556 15.2H10.9444C10.2172 15.2 9.854 15.2 9.58333 15.072C9.41419 14.994 9.26722 14.8728 9.15633 14.72C9 14.4968 9 14.1984 9 13.6Z",
    stroke: "#4776E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.66b76bc295f91e773d80911218aeffd9.svg";
export { ForwardRef as ReactComponent };